import { Injectable } from '@angular/core';
import { ConstantService } from '../../core/services/constant.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { InsuranceConsult } from 'src/app/models/desgravamen/insurance-consult';

@Injectable({
  providedIn: 'root'
})
export class InsuranceConsultService {
  private insuranceConsultURL = ConstantService.INSURANCE_CONSULT_URL;

  constructor(private http: HttpClient) { }

  getList(project_id): Observable<any> {
    return this.http.get<{}>(`${this.insuranceConsultURL}?pageSize=10000&startIndex=0&project_id=${project_id}&is_active=true`).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getByID(id: string): Observable<any> {
    return this.http.get<{}>(`${this.insuranceConsultURL}${id}`)
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  getInsuranceConsultByCreditNumber(params: any): Observable<any> {
      let httpParams = new HttpParams().set("credit_number", params);
  
      return this.http
        .get<any>(this.insuranceConsultURL, { params: httpParams })
        .pipe(map((response) => response));
    }


      getListByProject_Credit_ID(
    project_id: string,
    identification_number: string,
    credit_number: string
  ): Observable<any> {
    return this.http
      .get<{}>(
        `${this.insuranceConsultURL}?project_id=${project_id}&identification_number=${identification_number}&credit_number=${credit_number}&is_active=true`
      )
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  getGeneratedDocuments(insuranceId: string): Observable<any> {
    return this.http.post<any>(ConstantService.DESGRAVAMEN_DOCUMENTS_URL, {
      insurance_id: insuranceId
    });
  }

  
  patch(data: any): Observable<any> {
    return this.http.patch<any>(`${this.insuranceConsultURL}${data.id}`, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  post(data: InsuranceConsult): Observable<any> {
    return this.http.post<any>(this.insuranceConsultURL, data).pipe(
      map((response) => {
        return response;
      })
    );
  }


  delete(id: string): Observable<any> {
    const url = `${this.insuranceConsultURL}${id}`;
    return this.http.delete<any>(url).pipe(
      map(response => response)
    );
  }

  postDownloadReport(data: any): Observable<Blob> {
    let params = new HttpParams()
      .set('project_id', data['project_id'])
      .set('fecha_inicio', data['fecha_inicio'])
      .set('fecha_fin', data['fecha_fin']);

    if (data['is_active'] !== null && data['is_active'] !== undefined && data['is_active'] !== '') {
      params = params.set('is_active', String(data['is_active']));
    }

    return this.http.post(`${this.insuranceConsultURL}download-report/`, {}, {
      params,
      responseType: 'blob'
    });
  }

}
